"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _SttHeading = _interopRequireDefault(require("./SttTypography/SttHeading"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["outModalClose", "title", "iconClose", "children", "footer", "open"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      backgroundColor: "#f2f2f2"
    },
    heading: {
      backgroundColor: theme.palette.primary.main,
      color: "#F7F7F7"
    },
    footer: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      textAlign: "right",
      backgroundColor: "#f7f7f7"
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: "#F7F7F7"
    }
  };
});
SttModal.propTypes = {
  title: _propTypes["default"].string,
  children: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  outModalClose: _propTypes["default"].func,
  iconClose: _propTypes["default"].func,
  open: _propTypes["default"].bool.isRequired
};
SttModal.defaultProps = {
  open: false
};
function SttModal(props) {
  var classes = useStyles();
  var outModalClose = props.outModalClose,
    title = props.title,
    iconClose = props.iconClose,
    children = props.children,
    footer = props.footer,
    open = props.open,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], _extends({
    open: open
  }, other, {
    onClose: outModalClose
  }), /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    className: classes.heading,
    disableTypography: true
  }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    variant: "h2",
    color: "inherit"
  }, title), iconClose && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: iconClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
    className: classes.paper
  }, children), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
    className: classes.footer
  }, footer));
}
var _default = SttModal;
exports["default"] = _default;